import Component from '../core/Component'

export default class AdminPanel extends Component {

    constructor(element) {
        super(element);

        const adminPanel = document.querySelector(".admin-panel");
        let adminPanelTimer = [],
            adminPanelSlide,
            adminPanelObserver = new MutationObserver(observerCallback),
            adminPanelItems = document.querySelectorAll(".admin-panel__item.eval");
        // if admin pannel is in accordion slider (hp)
        if (document.querySelector("#adminPanel")) {
            adminPanelSlide = document.querySelector("#adminPanel");
            adminPanelObserver.observe(adminPanelSlide, adminPanel, {
                attributes: true,
                attributeFilter: ["class"]
            });
        //  if elsewhere
        } else {
            adminPanelObserver.observe(adminPanel, {
                attributes: true,
                attributeFilter: ["class"]
            });
        }

        function observerCallback() {
            if (adminPanelSlide) {
                adminPanelSlide.classList.contains("is-active") ? adminPanelAnimation(true) : adminPanelAnimation(false);
            } else {
                adminPanel.classList.contains('seen') ? adminPanelAnimation(true) : adminPanelAnimation(false);
            }
        }

        function adminPanelAnimation(playState) {
            if (playState == true) {
                setTimeout(function () {
                    for (let i = 0; i < adminPanelItems.length; i++) {
                        adminPanelTimer.push(setTimeout(function () {
                            adminPanelItems[i].classList.add("correction");
                            adminPanelTimer.push(setTimeout(function () {
                                adminPanelItems[i].classList.remove("wblock--disabled");
                            }, i + 1 * 1120));
                        }, i * 1120));
                    }
                }, 640);
            }
            if (playState == false) {
                adminPanelTimer.forEach(function (timer) {
                    clearTimeout(timer);
                });
                for (let i = 0; i < adminPanelItems.length; i++) {
                    adminPanelItems[i].classList.remove("correction")
                    adminPanelItems[i].classList.add("wblock--disabled");
                }
            }
        }
    }
    prepare() {}
}